{
  "labels": {
    "paste": "අලවන්න",
    "pasteAsPlaintext": "සරල පෙළ ලෙස අලවන්න",
    "pasteCharts": "ප්‍රස්ථාරය",
    "selectAll": "සියල්ලම",
    "multiSelect": "තෝරා ගැනීමට අංගය එකතු කරන්න",
    "moveCanvas": "කැන්වසය චලනය කරන්න",
    "cut": "කපන්න",
    "copy": "පිටපත් කරන්න",
    "copyAsPng": "PNG ලෙස පිටපත් කරන්න",
    "copyAsSvg": "SVG ලෙස පිටපත් කරන්න",
    "copyText": "පෙළ පිටපත් කරන්න",
    "copySource": "මූලාශ්‍රය පිටපත් කරන්න",
    "convertToCode": "කේතයට පරිවර්තනය කරන්න",
    "bringForward": "ඉදිරියට ගෙන්න",
    "sendToBack": "පසුපසටම ගෙනියන්න",
    "bringToFront": "ඉදිරියටම ගෙන්න",
    "sendBackward": "පසුපසට ගෙනියන්න",
    "delete": "මකන්න",
    "copyStyles": "ශෛලීන් පිටපත් කරන්න",
    "pasteStyles": "ශෛලීන් අලවන්න",
    "stroke": "පහර",
    "changeStroke": "",
    "background": "පසුබිම",
    "changeBackground": "",
    "fill": "පිරවුම",
    "strokeWidth": "පහර පළල",
    "strokeStyle": "පහර ශෛලිය",
    "strokeStyle_solid": "ඝන",
    "strokeStyle_dashed": "කඩකිරීම්",
    "strokeStyle_dotted": "තිත් සහිත",
    "sloppiness": "අනියම් බව",
    "opacity": "පාරදෘශ්‍යතාව",
    "textAlign": "පෙළ පෙළගැස්ම",
    "edges": "දාර",
    "sharp": "තියුණු",
    "round": "වට",
    "arrowheads": "ඊතල හිස",
    "arrowhead_none": "කිසිවක් නැත",
    "arrowhead_arrow": "ඊතලය",
    "arrowhead_bar": "බාර්",
    "arrowhead_circle": "වෘත්තය",
    "arrowhead_circle_outline": "වෘත්ත රූපරේඛාව",
    "arrowhead_triangle": "ත්‍රිකෝණය",
    "arrowhead_triangle_outline": "ත්‍රිකෝණ රූපරේඛාව",
    "arrowhead_diamond": "දියමන්ති",
    "arrowhead_diamond_outline": "දියමන්ති රූපරේඛාව",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "අකුරු ප්‍රමාණය",
    "fontFamily": "අකුරු පවුල",
    "addWatermark": "ජලසලකුණ එක් කරන්න",
    "handDrawn": "අතින් ඇඳි",
    "normal": "සාමාන්‍ය",
    "code": "කේත",
    "small": "කුඩා",
    "medium": "මධ්‍යම",
    "large": "විශාල",
    "veryLarge": "ඉතා විශාල",
    "solid": "ඝන",
    "hachure": "හැචුර",
    "zigzag": "සිග්සැග්",
    "crossHatch": "හරස් හැචුර",
    "thin": "කෙට්ටු",
    "bold": "තද",
    "left": "වම",
    "center": "මැද",
    "right": "දකුණ",
    "extraBold": "ඉතා තද",
    "architect": "වාස්තුවේදීයා",
    "artist": "කලාකරු",
    "cartoonist": "සැකිලිරූකරු",
    "fileTitle": "ගොනු නාමය",
    "colorPicker": "පාට තෝරකය",
    "canvasColors": "කැන්වස පාට",
    "canvasBackground": "කැන්වස පසුබිම",
    "drawingCanvas": "චිත්‍රක කැන්වසය",
    "clearCanvas": "",
    "layers": "ලේයර",
    "actions": "ක්‍රියාකාරකම",
    "language": "භාෂාව",
    "liveCollaboration": "සජීවී සහයෝගිතාව",
    "duplicateSelection": "තෝරාගැනීම පිටපත් කරන්න",
    "untitled": "නිර්නාමික",
    "name": "නම",
    "yourName": "ඔබගේ නම",
    "madeWithExcalidraw": "Excalidraw සමඟ සාදන ලද",
    "group": "කණ්ඩායම",
    "ungroup": "කණ්ඩායම් ඉවත් කරන්න",
    "collaborators": "සහයෝගිකයන්",
    "toggleGrid": "",
    "addToLibrary": "පුස්තකාලයට එක් කරන්න",
    "removeFromLibrary": "පුස්තකාලයෙන් ඉවත් කරන්න",
    "libraryLoadingMessage": "පුස්තකාලය පූරණය වෙමින් පවතී",
    "libraries": "පුස්තකාල",
    "loadingScene": "දර්ශනය පූරණය වෙමින්",
    "loadScene": "",
    "align": "පෙළගැස්වීම",
    "alignTop": "ඉහළට පෙළගස්වන්න",
    "alignBottom": "පහළට පෙළගස්වන්න",
    "alignLeft": "වමට පෙළගස්වන්න",
    "alignRight": "දකුණට පෙළගස්වන්න",
    "centerVertically": "සිරස්ව මැදට",
    "centerHorizontally": "තිරස්ව මැදට",
    "distributeHorizontally": "තිරස්ව බෙදාහරින්න",
    "distributeVertically": "සිරස්ව බෙදාහරින්න",
    "flipHorizontal": "තිරස්ව පෙරළන්න",
    "flipVertical": "සිරස්ව පෙරළන්න",
    "viewMode": "දසුන් මාදිලිය",
    "share": "බෙදාහදා ගන්න",
    "showStroke": "පහර පෙන්වන්න",
    "showBackground": "පසුබිම පෙන්වන්න",
    "showFonts": "",
    "toggleTheme": "තේමාව ටොගල් කරන්න",
    "theme": "",
    "personalLib": "පුද්ගලික පුස්තකාලය",
    "excalidrawLib": "Excalidraw පුස්තකාලය",
    "decreaseFontSize": "අකුරු ප්‍රමාණය අඩු කරන්න",
    "increaseFontSize": "අකුරු ප්‍රමාණය වැඩි කරන්න",
    "unbindText": "පෙළ විසන්ධි කරන්න",
    "bindText": "පෙළ බන්ධනය කරන්න",
    "createContainerFromText": "පෙළෙන් බහාලුමක් සාදන්න",
    "link": {
      "edit": "සංස්කරණය",
      "editEmbed": "බිහිදැමීම සංස්කරණය",
      "create": "සාදන්න",
      "label": "ලේබලය",
      "labelEmbed": "බිහිදැමීම ලේබලය",
      "empty": "හිස්",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "සංස්කරණය",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "අගුලු දමන්න",
      "unlock": "අගුලු ඉවත් කරන්න",
      "lockAll": "සියල්ල අගුලු දමන්න",
      "unlockAll": "සියල්ල අගුලු ඉවත් කරන්න"
    },
    "statusPublished": "ප්‍රකාශිත තත්ත්වය",
    "sidebarLock": "පැති තීරුව අගුලු",
    "selectAllElementsInFrame": "අඳින ලද රාමුවේ සියලුම අංග තෝරන්න",
    "removeAllElementsFromFrame": "රාමුවෙන් සියලුම අංග ඉවත් කරන්න",
    "eyeDropper": "අක්ෂි බිංදුකරු",
    "textToDiagram": "පෙළෙන් රූපසටහනකට",
    "prompt": "ප්‍රේරකය",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "අයිතම නැත",
    "hint_emptyLibrary": "පුස්තකාලය හිස් බව පෙන්වයි",
    "hint_emptyPrivateLibrary": "පුද්ගලික පුස්තකාලය හිස් බව පෙන්වයි",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "පිරිසිදු කර ප්‍රතිස්ථාපනය",
    "exportJSON": "JSON ලෙස නිර්යාත කරන්න",
    "exportImage": "පින්තූරය ලෙස නිර්යාත කරන්න",
    "export": "නිර්යාත",
    "copyToClipboard": "ක්ලිප්බෝඩ් එකට පිටපත් කරන්න",
    "copyLink": "",
    "save": "සුරකින්න",
    "saveAs": "ලෙස සුරකින්න",
    "load": "පූරණය",
    "getShareableLink": "බෙදාහැරිය හැකි සබැඳිය ලබා ගන්න",
    "close": "වසන්න",
    "selectLanguage": "භාෂාව තෝරන්න",
    "scrollBackToContent": "අන්තර්ගතයට ආපසු යන්න",
    "zoomIn": "විශාලනය",
    "zoomOut": "කුඩාකිරීම",
    "resetZoom": "විශාලනය යළි සකසන්න",
    "menu": "මෙනුව",
    "done": "සම්පූර්ණයි",
    "edit": "සංස්කරණය",
    "undo": "පසුගමන",
    "redo": "නැවත කරන්න",
    "resetLibrary": "පුස්තකාලය යළි සකසන්න",
    "createNewRoom": "නව කාමරයක් සාදන්න",
    "fullScreen": "පූර්ණ තිරය",
    "darkMode": "අඳුරු මාදිලිය",
    "lightMode": "ලා පැහැ මාදිලිය",
    "systemMode": "",
    "zenMode": "සෙන් මාදිලිය",
    "objectsSnapMode": "වස්තු ස්නැප් මාදිලිය",
    "exitZenMode": "සෙන් මාදිලියෙන් ඉවත් වන්න",
    "cancel": "අවලංගු කරන්න",
    "saveLibNames": "",
    "clear": "පිරිසිදු",
    "remove": "ඉවත් කරන්න",
    "embed": "බිහිදැමීම",
    "publishLibrary": "",
    "submit": "ඉදිරිපත් කරන්න",
    "confirm": "තහවුරු කරන්න",
    "embeddableInteractionButton": "බිහිදැමීමේ අන්තර්ක්‍රියා බොත්තම"
  },
  "alerts": {
    "clearReset": "පිරිසිදු කිරීම හා යළි සැකසීම ගැන ඇඟවීම",
    "couldNotCreateShareableLink": "බෙදාහැරිය හැකි සබැඳියක් සෑදීමට නොහැකි විය",
    "couldNotCreateShareableLinkTooBig": "බෙදාහැරිය හැකි සබැඳියක් ඉතා විශාල බැවින් සෑදීමට නොහැකි විය",
    "couldNotLoadInvalidFile": "වලංගු නොවන ගොනුවක් පූරණය කළ නොහැක",
    "importBackendFailed": "පසුබිම ආයාතය අසාර්ථකයි",
    "cannotExportEmptyCanvas": "හිස් කැන්වසයක් නිර්යාත කළ නොහැක",
    "couldNotCopyToClipboard": "ක්ලිප්බෝඩ් එකට පිටපත් කළ නොහැක",
    "decryptFailed": "විකේතනය අසාර්ථකයි",
    "uploadedSecurly": "ආරක්ෂිතව උඩුගත කරන ලදි",
    "loadSceneOverridePrompt": "දර්ශනය පූරණය කිරීම ආවරණය ගැන ඇඟවීම",
    "collabStopOverridePrompt": "සහයෝගිතාව නැවැත්වීම ආවරණය ගැන ඇඟවීම",
    "errorAddingToLibrary": "පුස්තකාලයට එක් කිරීමේ දෝෂය",
    "errorRemovingFromLibrary": "පුස්තකාලයෙන් ඉවත් කිරීමේ දෝෂය",
    "confirmAddLibrary": "පුස්තකාලයට එක් කිරීම තහවුරු කරන්න",
    "imageDoesNotContainScene": "පින්තූරයේ දර්ශනයක් අඩංගු නොවේ",
    "cannotRestoreFromImage": "පින්තූරයෙන් ප්‍රතිස්ථාපනය කළ නොහැක",
    "invalidSceneUrl": "වලංගු නොවන දර්ශන URL",
    "resetLibrary": "පුස්තකාලය යළි සකසන්න",
    "removeItemsFromsLibrary": "පුස්තකාලයෙන් අයිතම ඉවත් කරන්න",
    "invalidEncryptionKey": "වලංගු නොවන ගුප්තකේතන යතුර",
    "collabOfflineWarning": "සහයෝගිතාව ඕෆ්ලයින් ඇඟවීම",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "සහාය නොදක්වන ගොනු වර්ගය",
    "imageInsertError": "පින්තූර ඇතුළත් කිරීමේ දෝෂය",
    "fileTooBig": "ගොනුව ඉතා විශාලයි",
    "svgImageInsertError": "SVG පින්තූර ඇතුළත් කිරීමේ දෝෂය",
    "failedToFetchImage": "පින්තූරය ලබා ගැනීමට අසමත් විය",
    "cannotResolveCollabServer": "සහයෝගිතා සේවාදායකය විසඳිය නොහැක",
    "importLibraryError": "පුස්තකාල ආයාත දෝෂය",
    "saveLibraryError": "",
    "collabSaveFailed": "සහයෝගිතා සුරැකීම අසාර්ථකයි",
    "collabSaveFailed_sizeExceeded": "ප්‍රමාණය ඉක්මවූ බැවින් සහයෝගිතා සුරැකීම අසාර්ථකයි",
    "imageToolNotSupported": "පින්තූර මෙවලම සහාය නොදක්වයි",
    "brave_measure_text_error": {
      "line1": "බ්‍රේව් බ්‍රව්සරයේ පෙළ මැනීමේ දෝෂය",
      "line2": "මෙම දෝෂය බ්‍රේව් බ්‍රව්සරයේ ගැටලුවකි",
      "line3": "කරුණාකර වෙනත් බ්‍රව්සරයක් භාවිතා කරන්න",
      "line4": "අපගේ උපදෙස් පිටුවට පිවිසෙන්න"
    },
    "libraryElementTypeError": {
      "embeddable": "බිහිදැමිය හැකි අංග වර්ග දෝෂය",
      "iframe": "iframe අංග වර්ග දෝෂය",
      "image": "පින්තූර අංග වර්ග දෝෂය"
    },
    "asyncPasteFailedOnRead": "අසින්ක් ඇලවීම කියවීමේදී අසාර්ථකයි",
    "asyncPasteFailedOnParse": "අසින්ක් ඇලවීම විග්‍රහ කිරීමේදී අසාර්ථකයි",
    "copyToSystemClipboardFailed": "පද්ධති ක්ලිප්බෝඩ් එකට පිටපත් කිරීම අසාර්ථකයි"
  },
  "toolBar": {
    "selection": "තේරීම",
    "lasso": "",
    "image": "පින්තූරය",
    "rectangle": "සෘජුකෝණාස්‍රය",
    "diamond": "දියමන්ති",
    "ellipse": "ඉලිප්සය",
    "arrow": "ඊතලය",
    "line": "රේඛාව",
    "freedraw": "නිදහස් ඇඳීම",
    "text": "පෙළ",
    "library": "පුස්තකාලය",
    "lock": "අගුල",
    "penMode": "පෑන් මාදිලිය",
    "link": "සබැඳිය",
    "eraser": "මකනය",
    "frame": "රාමුව",
    "magicframe": "මැජික් රාමුව",
    "embeddable": "බිහිදැමිය හැකි",
    "laser": "ලේසර්",
    "hand": "අත",
    "extraTools": "අමතර මෙවලම්",
    "mermaidToExcalidraw": "Mermaid වලින් Excalidraw වෙත",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "කැන්වස ක්‍රියා",
    "selectedShapeActions": "තෝරාගත් හැඩතල ක්‍රියා",
    "shapes": "හැඩතල"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "රේඛීය අංගය",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "නිදහස් ඇඳීම",
    "text": "පෙළ",
    "embeddable": "බිහිදැමිය හැකි",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "පුස්තකාලය ප්‍රකාශනය",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Firefox ක්ලිප්බෝඩ් ලිවීම",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "පූර්වදර්ශනය පෙන්විය නොහැක",
    "canvasTooBig": "කැන්වසය ඉතා විශාලයි",
    "canvasTooBigTip": "කැන්වසය ඉතා විශාල බවට ඉඟිය"
  },
  "errorSplash": {
    "headingMain": "ප්‍රධාන දෝෂය",
    "clearCanvasMessage": "කැන්වසය පිරිසිදු කිරීමේ පණිවිඩය",
    "clearCanvasCaveat": "කැන්වසය පිරිසිදු කිරීමේ සීමාව",
    "trackedToSentry": "Sentry වෙත ලුහුබඳින ලදි",
    "openIssueMessage": "නිකුතුව විවෘත කිරීමේ පණිවිඩය",
    "sceneContent": "දර්ශන අන්තර්ගතය"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "කාමර සංවාද හැඳින්වීම",
    "desc_privacy": "පෞද්ගලිකත්ව විස්තර",
    "button_startSession": "සැසිය ආරම්භ කරන්න",
    "button_stopSession": "සැසිය නවත්වන්න",
    "desc_inProgressIntro": "පවත්නා සැසි හැඳින්වීම",
    "desc_shareLink": "බෙදාහැරිය හැකි සබැඳි විස්තර",
    "desc_exitSession": "සැසියෙන් ඉවත්වීමේ විස්තර",
    "shareTitle": "බෙදාහැරීමේ මාතෘකාව"
  },
  "errorDialog": {
    "title": "දෝෂ සංවාද මාතෘකාව"
  },
  "exportDialog": {
    "disk_title": "තැටි මාතෘකාව",
    "disk_details": "තැටි විස්තර",
    "disk_button": "තැටි බොත්තම",
    "link_title": "සබැඳි මාතෘකාව",
    "link_details": "සබැඳි විස්තර",
    "link_button": "සබැඳි බොත්තම",
    "excalidrawplus_description": "ExcalidrawPlus විස්තර",
    "excalidrawplus_button": "ExcalidrawPlus බොත්තම",
    "excalidrawplus_exportError": "ExcalidrawPlus නිර්යාත දෝෂය"
  },
  "helpDialog": {
    "blog": "බ්ලොග්",
    "click": "ක්ලික්",
    "deepSelect": "ගැඹුරු තේරීම",
    "deepBoxSelect": "ගැඹුරු කොටු තේරීම",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "වක්‍ර ඊතලය",
    "curvedLine": "වක්‍ර රේඛාව",
    "documentation": "ලේඛන",
    "doubleClick": "ද්විත්ව ක්ලික්",
    "drag": "අදින්න",
    "editor": "සංස්කාරක",
    "editLineArrowPoints": "රේඛා ඊතල ලක්ෂ්‍ය සංස්කරණය",
    "editText": "පෙළ සංස්කරණය",
    "github": "GitHub",
    "howto": "කෙසේද",
    "or": "හෝ",
    "preventBinding": "බන්ධනය වැළැක්වීම",
    "tools": "මෙවලම්",
    "shortcuts": "කෙටිමං",
    "textFinish": "පෙළ අවසන්",
    "textNewLine": "පෙළ නව රේඛාව",
    "title": "මාතෘකාව",
    "view": "දසුන",
    "zoomToFit": "විශාලනයට ගැළපීම",
    "zoomToSelection": "තේරීමට විශාලනය",
    "toggleElementLock": "අංග අගුලු ටොගල්",
    "movePageUpDown": "පිටුව ඉහළට/පහළට ගෙනයාම",
    "movePageLeftRight": "පිටුව වමට/දකුණට ගෙනයාම",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "කැන්වසය පිරිසිදු කිරීමේ සංවාදය"
  },
  "publishDialog": {
    "title": "ප්‍රකාශන සංවාදය",
    "itemName": "අයිතම නම",
    "authorName": "කතුවරයාගේ නම",
    "githubUsername": "GitHub පරිශීලක නම",
    "twitterUsername": "Twitter පරිශීලක නම",
    "libraryName": "පුස්තකාලයේ නම",
    "libraryDesc": "පුස්තකාල විස්තර",
    "website": "වෙබ් අඩවිය",
    "placeholder": {
      "authorName": "කතුවරයාගේ නම ඇතුලත් කරන්න",
      "libraryName": "පුස්තකාලයේ නම ඇතුලත් කරන්න",
      "libraryDesc": "පුස්තකාල විස්තර ඇතුලත් කරන්න",
      "githubHandle": "GitHub හසුරුව ඇතුලත් කරන්න",
      "twitterHandle": "Twitter හසුරුව ඇතුලත් කරන්න",
      "website": "වෙබ් අඩවිය ඇතුලත් කරන්න"
    },
    "errors": {
      "required": "අවශ්‍යයි",
      "website": "වලංගු නොවන වෙබ් අඩවි URL"
    },
    "noteDescription": "සටහන් විස්තර",
    "noteGuidelines": "සටහන් මාර්ගෝපදේශ",
    "noteLicense": "සටහන් බලපත්‍රය",
    "noteItems": "සටහන් අයිතම",
    "atleastOneLibItem": "අවම වශයෙන් එක් පුස්තකාල අයිතමයක්",
    "republishWarning": "නැවත ප්‍රකාශන ඇඟවීම"
  },
  "publishSuccessDialog": {
    "title": "ප්‍රකාශන සාර්ථකත්ව සංවාදය",
    "content": "ප්‍රකාශන සාර්ථකත්ව අන්තර්ගතය"
  },
  "confirmDialog": {
    "resetLibrary": "පුස්තකාලය යළි සකස් කිරීම තහවුරු කරන්න",
    "removeItemsFromLib": "පුස්තකාලයෙන් අයිතම ඉවත් කිරීම තහවුරු කරන්න"
  },
  "imageExportDialog": {
    "header": "පින්තූර නිර්යාත සංවාදය",
    "label": {
      "withBackground": "පසුබිම සමඟ",
      "onlySelected": "තෝරාගත් පමණක්",
      "darkMode": "අඳුරු මාදිලිය",
      "embedScene": "දර්ශනය බිහිදැමීම",
      "scale": "පරිමාණය",
      "padding": "පෑඩිං"
    },
    "tooltip": {
      "embedScene": "දර්ශනය බිහිදැමීම ගැන ඉඟිය"
    },
    "title": {
      "exportToPng": "PNG ලෙස නිර්යාත",
      "exportToSvg": "SVG ලෙස නිර්යාත",
      "copyPngToClipboard": "PNG ලෙස ක්ලිප්බෝඩ් එකට පිටපත්"
    },
    "button": {
      "exportToPng": "PNG ලෙස නිර්යාත කරන්න",
      "exportToSvg": "SVG ලෙස නිර්යාත කරන්න",
      "copyPngToClipboard": "PNG ලෙස ක්ලිප්බෝඩ් එකට පිටපත් කරන්න"
    }
  },
  "encrypted": {
    "tooltip": "ගුප්තකේතන ඉඟිය",
    "link": "ගුප්තකේතන සබැඳිය"
  },
  "stats": {
    "angle": "කෝණය",
    "shapes": "",
    "height": "උස",
    "scene": "දර්ශනය",
    "selected": "තෝරාගත්",
    "storage": "ගබඩා",
    "fullTitle": "",
    "title": "සංඛ්‍යාලේඛන මාතෘකාව",
    "generalStats": "",
    "elementProperties": "",
    "total": "මුළු",
    "version": "අනුවාදය",
    "versionCopy": "අනුවාද පිටපත",
    "versionNotAvailable": "අනුවාදය ලබා ගත නොහැක",
    "width": "පළල"
  },
  "toast": {
    "addedToLibrary": "පුස්තකාලයට එක් කරන ලදි",
    "copyStyles": "ශෛලීන් පිටපත් කරන ලදි",
    "copyToClipboard": "ක්ලිප්බෝඩ් එකට පිටපත් කරන ලදි",
    "copyToClipboardAsPng": "PNG ලෙස ක්ලිප්බෝඩ් එකට පිටපත් කරන ලදි",
    "copyToClipboardAsSvg": "",
    "fileSaved": "ගොනුව සුරැකිණි",
    "fileSavedToFilename": "ගොනුව ගොනු නාමයට සුරැකිණි",
    "canvas": "කැන්වස ටෝස්ට්",
    "selection": "තේරීම ටෝස්ට්",
    "pasteAsSingleElement": "තනි අංගයක් ලෙස ඇලවීම",
    "unableToEmbed": "බිහිදැමීමට නොහැක",
    "unrecognizedLinkFormat": "නොහඳුනන සබැඳි ආකෘතිය",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "පාරදෘශ්‍ය",
    "black": "කළු",
    "white": "සුදු",
    "red": "රතු",
    "pink": "රෝස",
    "grape": "දම්",
    "violet": "දම්පාට",
    "gray": "අළු",
    "blue": "නිල්",
    "cyan": "සයන්",
    "teal": "ටීල්",
    "green": "කොළ",
    "yellow": "කහ",
    "orange": "තැඹිලි",
    "bronze": "ලෝකඩ"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "අයදුම් මධ්‍ය ශීර්ෂය Plus",
      "menuHint": "මෙනු ඉඟිය"
    },
    "defaults": {
      "menuHint": "පෙරනිමි මෙනු ඉඟිය",
      "center_heading": "පෙරනිමි මධ්‍ය ශීර්ෂය",
      "toolbarHint": "මෙවලම් තීරු ඉඟිය",
      "helpHint": "උපකාර ඉඟිය"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "බහුලව භාවිතා වන අභිරුචි පාට",
    "colors": "පාට",
    "shades": "සෙවනැලි",
    "hexCode": "හෙක්ස් කේත",
    "noShades": "සෙවනැලි නැත"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "පින්තූරයට නිර්යාත ආවරණය",
        "button": "පින්තූරයට නිර්යාත බොත්තම",
        "description": "පින්තූරයට නිර්යාත විස්තර"
      },
      "saveToDisk": {
        "title": "තැටියට සුරැකීම ආවරණය",
        "button": "තැටියට සුරැකීම බොත්තම",
        "description": "තැටියට සුරැකීම විස්තර"
      },
      "excalidrawPlus": {
        "title": "ExcalidrawPlus ආවරණය",
        "button": "ExcalidrawPlus බොත්තම",
        "description": "ExcalidrawPlus විස්තර"
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "ගොනුවෙන් පූරණය ආවරණය",
        "button": "ගොනුවෙන් පූරණය බොත්තම",
        "description": "ගොනුවෙන් පූරණය විස්තර"
      },
      "shareableLink": {
        "title": "බෙදාහැරිය හැකි සබැඳි ආවරණය",
        "button": "බෙදාහැරිය හැකි සබැඳි බොත්තම",
        "description": "බෙදාහැරිය හැකි සබැඳි විස්තර"
      }
    }
  },
  "mermaid": {
    "title": "Mermaid මාතෘකාව",
    "button": "Mermaid බොත්තම",
    "description": "Mermaid විස්තර",
    "syntax": "Mermaid වාක්‍ය ඛණ්ඩය",
    "preview": "Mermaid පූර්වදර්ශනය",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
